import { render, staticRenderFns } from "./Uploads.vue?vue&type=template&id=b43fada4&"
import script from "./Uploads.vue?vue&type=script&lang=js&"
export * from "./Uploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports